import React, { useEffect, useState } from 'react';
import './version.scss';

const Version = () => <span className="version">{process.env.REACT_APP_VERSION}</span>;

export default Version;
